import { PageContainer } from '@components';
import { Contributions } from '@views/Contributions';
import { GetProjectsAchievementPayloadType } from '@api';
import { useRequestParams } from '@hooks';
import { store } from '@store';
import { useEffect } from 'react';

const ContributionsPage = () => {
  const projectsAchievementFiltered = store.use.projectsAchievementFiltered();
  const getProjectsAchievementAction = store.use.getProjectsAchievementAction().call;
  const isLoadingGetProjectsAchievementAction =
    store.use.getProjectsAchievementAction().status === 'LOADING';

  const { afterPageChange, reqParams, pagination } =
    useRequestParams<GetProjectsAchievementPayloadType>();

  useEffect(() => {
    getProjectsAchievementAction(reqParams);
  }, [JSON.stringify(reqParams)]);

  useEffect(() => {
    afterPageChange(projectsAchievementFiltered.length);
  }, [projectsAchievementFiltered.length]);

  return (
    <PageContainer>
      <Contributions
        projectsAchievement={projectsAchievementFiltered}
        isLoading={isLoadingGetProjectsAchievementAction}
        tableProps={{ pagination }}
      />
    </PageContainer>
  );
};

export default ContributionsPage;
